import { __decorate } from "tslib";
import Vue from "vue";
import Component from "vue-class-component";
import VInput from "@/classes/VInput";
import { Watch } from "vue-property-decorator";
import Validators from "@/classes/Validators";
import ConfirmDialog from "@/components/ConfirmDialog.vue";
import { SoftDeletedUserError } from "@/store/modules/UserModule";
let Login = class Login extends Vue {
    email = "";
    password = "";
    loginError = "";
    isFormValid = false;
    keepLoggedIn = false;
    sending = false;
    passwordRules = [
        (value) => !!value || "Heslo nesmí být prázdné",
    ];
    emailRules = [
        (value) => !!value || "Email nesmí být prázdný",
        (value) => this.isEmailFormatValid(value) || "Email není ve správném formátu",
    ];
    isEmailFormatValid(text) {
        return Validators.isEmail(text);
    }
    async login() {
        this.sending = true;
        try {
            await this.$store.dispatch("user/auth", {
                email: this.email,
                password: this.password,
                persist: this.keepLoggedIn,
            });
            await this.$router.push("/");
        }
        catch (e) {
            this.sending = false;
            if (e instanceof SoftDeletedUserError) {
                this.loginError = "Tento účet byl deaktivován";
                this.passwordInput.pushCustomError("Tento účet byl deaktivován");
            }
            else {
                this.loginError = "Neplatné přihlašovací údaje";
                this.passwordInput.pushCustomError("Neplatné přihlašovací údaje");
            }
        }
    }
    async resetPassword() {
        if (!this.email || !Validators.isEmail(this.email)) {
            return;
        }
        try {
            await this.$store.dispatch("user/resetPassword", this.email);
        }
        catch (e) {
            // ignore to prevent email enumeration
        }
        finally {
            await ConfirmDialog.open('Hotovo', 'Na Váš email byl odeslán odkaz pro reset hesla, platnost odkazu je 1h!', 'Ok', 'Zrušit');
            this.sending = false;
        }
    }
    get passwordInput() {
        return new VInput(this.$refs.passwordInput);
    }
    onInputChanged() {
        this.loginError = "";
        this.passwordInput.clearCustomError("Neplatné přihlašovací údaje");
    }
};
__decorate([
    Watch("email"),
    Watch("password")
], Login.prototype, "onInputChanged", null);
Login = __decorate([
    Component
], Login);
export default Login;
